import { normalize } from 'normalizr';

import { notify } from 'utils/reduxUtils';

import * as entities from './entities';

export const types = {
  ARCHIVED_PARTS_LIST_ERROR: 'partLibrary/ARCHIVED_PARTS_LIST_ERROR',
  ARCHIVED_PARTS_LIST_REQUEST: 'partLibrary/ARCHIVED_PARTS_LIST_REQUEST',
  ARCHIVED_PARTS_LIST_SUCCESS: 'partLibrary/ARCHIVED_PART_LIST_SUCCESS',
  COPY_PARTS_TO_QUOTE_ERROR: 'partLibrary/COPY_PARTS_TO_QUOTE_ERROR',
  COPY_PARTS_TO_QUOTE_REQUEST: 'partLibrary/COPY_PARTS_TO_QUOTE_REQUEST',
  COPY_PARTS_TO_QUOTE_SUCCESS: 'partLibrary/COPY_PARTS_TO_QUOTE_SUCCESS',
  DRAFTED_QUOTES_ERROR: 'partLibrary/DRAFTED_QUOTES_ERROR',
  DRAFTED_QUOTES_REQUEST: 'partLibrary/DRAFTED_QUOTES_REQUEST',
  DRAFTED_QUOTES_SUCCESS: 'partLibrary/DRAFTED_QUOTES_SUCCESS',
  GET_ADDITIONAL_QUOTES_ERROR: 'partLibrary/GET_ADDITIONAL_QUOTES_ERROR',
  GET_ADDITIONAL_QUOTES_REQUEST: 'partLibrary/GET_ADDITIONAL_QUOTES_REQUEST',
  GET_ADDITIONAL_QUOTES_SUCCESS: 'partLibrary/GET_ADDITIONAL_QUOTES_SUCCESS',
  MERGE_PARTS_ERROR: 'partLibrary/MERGE_PARTS_ERROR',
  MERGE_PARTS_REQUEST: 'partLibrary/MERGE_PARTS_REQUEST',
  MERGE_PARTS_SUCCESS: 'partLibrary/MERGE_PARTS_SUCCESS',
  PART_LIBRARY_CHANGE_TAB: 'partLibrary/PART_LIBRARY_CHANGE_TAB',
  PART_LIBRARY_PAGE_ARCHIVE_PARTS_ERROR:
    'partLibrary/PART_LIBRARY_PAGE_ARCHIVE_PARTS_ERROR',
  PART_LIBRARY_PAGE_ARCHIVE_PARTS_REQUEST:
    'partLibrary/PART_LIBRARY_PAGE_ARCHIVE_PARTS_REQUEST',
  PART_LIBRARY_PAGE_ARCHIVE_PARTS_SUCCESS:
    'partLibrary/PART_LIBRARY_PAGE_ARCHIVE_PARTS_SUCCESS',
  PART_LIBRARY_PAGE_CLOSE_DRAWER: 'partLibrary/PART_LIBRARY_PAGE_CLOSE_DRAWER',
  PART_LIBRARY_PAGE_INIT: 'partLibrary/PART_LIBRARY_PAGE_INIT',
  PART_LIBRARY_PAGE_OPEN_DRAWER: 'partLibrary/PART_LIBRARY_PAGE_OPEN_DRAWER',
  PART_LIBRARY_PAGE_PAGINATE: 'partLibrary/PART_LIBRARY_PAGE_PAGINATE',
  PART_LIBRARY_PAGE_SEARCH: 'partLibrary/PART_LIBRARY_PAGE_SEARCH',
  PART_LIBRARY_PAGE_SET_PAGE: 'partLibrary/PART_LIBRARY_PAGE_SET_PAGE',
  PART_LIBRARY_PAGE_SET_TAB: 'partLibrary/PART_LIBRARY_PAGE_SET_TAB',
  PART_LIBRARY_PAGE_SET_SEARCH: 'partLibrary/PART_LIBRARY_PAGE_SET_SEARCH',
  PART_LIBRARY_PAGE_SET_IS_CREATING_QUOTE:
    'partLibrary/PART_LIBRARY_PAGE_SET_IS_CREATING_QUOTE',
  PART_LIBRARY_PAGE_ADD_SELECTED_PART:
    'partLibrary/PART_LIBRARY_PAGE_ADD_SELECTED_PART',
  PART_LIBRARY_PAGE_REMOVE_SELECTED_PART:
    'partLibrary/PART_LIBRARY_PAGE_REMOVE_SELECTED_PART',
  PART_LIBRARY_PAGE_SET_SELECTED_PARTS:
    'partLibrary/PART_LIBRARY_PAGE_SET_SELECTED_PARTS',
  PART_LIBRARY_PAGE_CLEAR_SELECTED_PARTS:
    'partLibrary/PART_LIBRARY_PAGE_CLEAR_SELECTED_PARTS',
  PART_LIBRARY_PAGE_OPEN_PART: 'partLibrary/PART_LIBRARY_PAGE_OPEN_PART',
  PART_LIBRARY_PAGE_OPEN_ACTION_BAR:
    'partLibrary/PART_LIBRARY_PAGE_OPEN_ACTION_BAR',
  PART_LIBRARY_PAGE_CLOSE_ACTION_BAR:
    'partLibrary/PART_LIBRARY_PAGE_CLOSE_ACTION_BAR',
  PART_LIBRARY_PAGE_RESTORE_PARTS_ERROR:
    'partLibrary/PART_LIBRARY_PAGE_RESTORE_PARTS_ERROR',
  PART_LIBRARY_PAGE_RESTORE_PARTS_REQUEST:
    'partLibrary/PART_LIBRARY_PAGE_RESTORE_PARTS_REQUEST',
  PART_LIBRARY_PAGE_RESTORE_PARTS_SUCCESS:
    'partLibrary/PART_LIBRARY_PAGE_RESTORE_PARTS_SUCCESS',
  PART_LIBRARY_PAGE_PURGE_PARTS_ERROR:
    'partLibrary/PART_LIBRARY_PAGE_PURGE_PARTS_ERROR',
  PART_LIBRARY_PAGE_PURGE_PARTS_REQUEST:
    'partLibrary/PART_LIBRARY_PAGE_PURGE_PARTS_REQUEST',
  PART_LIBRARY_PAGE_PURGE_PARTS_SUCCESS:
    'partLibrary/PART_LIBRARY_PAGE_PURGE_PARTS_SUCCESS',
  PART_LIBRARY_PAGE_OPEN_ADD_TO_QUOTE_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_OPEN_ADD_TO_QUOTE_DRAWER',
  PART_LIBRARY_PAGE_CLOSE_ADD_TO_QUOTE_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_CLOSE_ADD_TO_QUOTE_DRAWER',
  PART_LIBRARY_PAGE_SELECT_QUOTE: 'partLibrary/PART_LIBRARY_PAGE_SELECT_QUOTE',
  PART_LIBRARY_PAGE_DESELECT_QUOTE:
    'partLibrary/PART_LIBRARY_PAGE_DESELECT_QUOTE',
  PART_LIBRARY_PAGE_OPEN_NESTED_ADD_TO_QUOTE_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_OPEN_NESTED_ADD_TO_QUOTE_DRAWER',
  PART_LIBRARY_PAGE_CLOSE_NESTED_ADD_TO_QUOTE_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_CLOSE_NESTED_ADD_TO_QUOTE_DRAWER',
  PART_LIBRARY_PAGE_OPEN_MERGE_PARTS_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_OPEN_MERGE_PARTS_DRAWER',
  PART_LIBRARY_PAGE_CLOSE_MERGE_PARTS_DRAWER:
    'partLibrary/PART_LIBRARY_PAGE_CLOSE_MERGE_PARTS_DRAWER',
  PARTS_LIST_ERROR: 'partLibrary/PARTS_LIST_ERROR',
  PARTS_LIST_REQUEST: 'partLibrary/PARTS_LIST_REQUEST',
  PARTS_LIST_SUCCESS: 'partLibrary/PARTS_LIST_SUCCESS',
  RECEIVE_PART_ENTITIY: 'partLibrary/RECEIVE_PART_ENTITIY',
  RECEIVE_PART_STATUSES: 'partLibrary/RECEIVE_PART_STATUSES',
  SHARES_LIST_ERROR: 'partLibrary/SHARES_LIST_ERROR',
  SHARES_LIST_REQUEST: 'partLibrary/SHARES_LIST_REQUEST',
  SHARES_LIST_SUCCESS: 'partLibrary/SHARES_LIST_SUCCESS',
  UPLOAD_PART_FILE_SUCCESS: 'partLibrary/UPLOAD_PART_FILE_SUCCESS',
  UPLOAD_PART_FILES_ERROR: 'partLibrary/UPLOAD_PART_FILES_ERROR',
  UPLOAD_PART_FILES_REQUEST: 'partLibrary/UPLOAD_PART_FILES_REQUEST',
  UPLOAD_PART_FILES_SET_FILES: 'partLibrary/UPLOAD_PART_FILES_SET_FILES',
  UPLOAD_PART_FILES_SUCCESS: 'partLibrary/UPLOAD_PART_FILES_SUCCESS',
  UPLOAD_SUPPORTING_FILES_ERROR: 'partLibrary/UPLOAD_SUPPORTING_FILES_ERROR',
};

export const partsList = {
  error: notify(
    (error) => ({
      type: types.PARTS_LIST_ERROR,
      payload: error,
    }),
    'Failed to fetch parts',
  ),
  request: () => ({
    type: types.PARTS_LIST_REQUEST,
  }),
  success: (payload) => ({
    type: types.PARTS_LIST_SUCCESS,
    payload: {
      ...normalize(payload.results, [entities.partSchema]),
      count: payload.count,
    },
  }),
};

//handle getting parts that have been shared with this user
export const sharesList = {
  error: notify(
    (error) => ({
      type: types.SHARES_LIST_ERROR,
      payload: error,
    }),
    'Failed to fetch shared parts',
  ),
  request: () => ({
    type: types.SHARES_LIST_REQUEST,
  }),
  success: (payload) => ({
    type: types.SHARES_LIST_SUCCESS,
    payload: {
      ...normalize(payload.results, [entities.shareSchema]),
      count: payload.count,
    },
  }),
};

export const receivePart = (payload) => ({
  type: types.RECEIVE_PART_ENTITIY,
  payload: normalize(payload, entities.partSchema),
});

export const uploadPartFile = {
  success: (payload) => {
    const tempId = payload.tempId;
    delete payload.tempId;
    const normalized = normalize(payload, entities.partSchema);
    return {
      type: types.UPLOAD_PART_FILE_SUCCESS,
      payload: {
        ...normalized,
        tempId,
      },
    };
  },
};

export const uploadPartFiles = {
  error: notify(
    (error) => ({
      type: types.UPLOAD_PART_FILES_ERROR,
      payload: error,
    }),
    'Failed to upload part files',
  ),
  request: (payload) => ({
    type: types.UPLOAD_PART_FILES_REQUEST,
    payload,
  }),
  setFiles: (payload) => ({
    type: types.UPLOAD_PART_FILES_SET_FILES,
    payload,
  }),
  success: () => ({
    type: types.UPLOAD_PART_FILES_SUCCESS,
  }),
};

export const receivePartStatuses = ({ partStatuses }) => ({
  type: types.RECEIVE_PART_STATUSES,
  payload: { partStatuses },
});

export const partLibraryPage = {
  changeTab: ({ tab }) => ({
    type: types.PART_LIBRARY_CHANGE_TAB,
    payload: { tab },
  }),
  closeDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_CLOSE_DRAWER,
  }),
  init: () => ({
    type: types.PART_LIBRARY_PAGE_INIT,
  }),
  openDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_OPEN_DRAWER,
  }),
  paginate: ({ pageNumber }) => ({
    type: types.PART_LIBRARY_PAGE_PAGINATE,
    payload: {
      pageNumber,
    },
  }),
  search: ({ searchString }) => ({
    type: types.PART_LIBRARY_PAGE_SEARCH,
    payload: {
      searchString,
    },
  }),
  setPage: ({ pageNumber }) => ({
    type: types.PART_LIBRARY_PAGE_SET_PAGE,
    payload: {
      page: pageNumber,
    },
  }),
  setSearch: ({ searchString }) => ({
    type: types.PART_LIBRARY_PAGE_SET_SEARCH,
    payload: {
      searchString,
    },
  }),
  setTab: ({ tab }) => ({
    type: types.PART_LIBRARY_PAGE_SET_TAB,
    payload: {
      tab: tab,
    },
  }),
  addSelectedPart: ({ part }) => ({
    type: types.PART_LIBRARY_PAGE_ADD_SELECTED_PART,
    payload: { part },
  }),
  removeSelectedPart: ({ part }) => ({
    type: types.PART_LIBRARY_PAGE_REMOVE_SELECTED_PART,
    payload: { part },
  }),
  setSelectedParts: ({ selectedParts }) => ({
    type: types.PART_LIBRARY_PAGE_SET_SELECTED_PARTS,
    payload: { selectedParts },
  }),
  clearSelectedParts: () => ({
    type: types.PART_LIBRARY_PAGE_CLEAR_SELECTED_PARTS,
  }),
  openPart: ({ partMasterUuid, partMasterVersion }) => ({
    type: types.PART_LIBRARY_PAGE_OPEN_PART,
    payload: { partMasterUuid, partMasterVersion },
  }),
  openActionBar: () => ({
    type: types.PART_LIBRARY_PAGE_OPEN_ACTION_BAR,
  }),
  closeActionBar: () => ({
    type: types.PART_LIBRARY_PAGE_CLOSE_ACTION_BAR,
  }),
  openAddToQuoteDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_OPEN_ADD_TO_QUOTE_DRAWER,
  }),
  closeAddToQuoteDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_CLOSE_ADD_TO_QUOTE_DRAWER,
  }),
  openNestedAddToQuoteDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_OPEN_NESTED_ADD_TO_QUOTE_DRAWER,
  }),
  closeNestedAddToQuoteDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_CLOSE_NESTED_ADD_TO_QUOTE_DRAWER,
  }),
  selectQuote: ({ quote }) => ({
    type: types.PART_LIBRARY_PAGE_SELECT_QUOTE,
    payload: { quote },
  }),
  deselectQuote: () => ({
    type: types.PART_LIBRARY_PAGE_DESELECT_QUOTE,
  }),
  setIsCreatingQuote: ({ isCreatingQuote }) => ({
    type: types.PART_LIBRARY_PAGE_SET_IS_CREATING_QUOTE,
    payload: { isCreatingQuote },
  }),
  openMergePartsDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_OPEN_MERGE_PARTS_DRAWER,
  }),
  closeMergePartsDrawer: () => ({
    type: types.PART_LIBRARY_PAGE_CLOSE_MERGE_PARTS_DRAWER,
  }),
};

export const copyPartsToQuote = {
  error: notify(
    (error) => ({
      type: types.COPY_PARTS_TO_QUOTE_ERROR,
      payload: error,
    }),
    'Failed to copy parts to quote',
  ),
  request: () => ({
    type: types.COPY_PARTS_TO_QUOTE_REQUEST,
  }),
  success: () => ({
    type: types.COPY_PARTS_TO_QUOTE_SUCCESS,
  }),
};

export const archiveParts = {
  error: notify(
    (error) => ({
      type: types.PART_LIBRARY_PAGE_ARCHIVE_PARTS_ERROR,
      payload: error,
    }),
    'Failed to archive parts',
  ),
  request: () => ({
    type: types.PART_LIBRARY_PAGE_ARCHIVE_PARTS_REQUEST,
  }),
  success: notify(
    ({ numParts }) => ({
      type: types.PART_LIBRARY_PAGE_ARCHIVE_PARTS_SUCCESS,
      payload: { numParts },
    }),
    (action) => `Successfully archived ${action.payload.numParts} 
    ${action.payload.numParts > 1 ? 'parts' : 'part'}`,
  ),
};

export const restoreParts = {
  error: notify(
    (error) => ({
      type: types.PART_LIBRARY_PAGE_RESTORE_PARTS_ERROR,
      payload: error,
    }),
    'Failed to restore parts',
  ),
  request: () => ({
    type: types.PART_LIBRARY_PAGE_RESTORE_PARTS_REQUEST,
  }),
  success: notify(
    ({ numParts }) => ({
      type: types.PART_LIBRARY_PAGE_RESTORE_PARTS_SUCCESS,
      payload: { numParts },
    }),
    (action) => `Successfully restored ${action.payload.numParts} 
    ${action.payload.numParts > 1 ? 'parts' : 'part'}`,
  ),
};

export const purgeParts = {
  error: notify(
    (error) => ({
      type: types.PART_LIBRARY_PAGE_PURGE_PARTS_ERROR,
      payload: error,
    }),
    'Failed to purge parts',
  ),
  request: () => ({
    type: types.PART_LIBRARY_PAGE_PURGE_PARTS_REQUEST,
  }),
  success: notify(
    ({ numParts }) => ({
      type: types.PART_LIBRARY_PAGE_PURGE_PARTS_SUCCESS,
      payload: { numParts },
    }),
    (action) => `Successfully deleted ${action.payload.numParts} 
    ${action.payload.numParts > 1 ? 'parts' : 'part'}`,
  ),
};

export const archivedPartsList = {
  error: notify(
    (error) => ({
      type: types.ARCHIVED_PARTS_LIST_ERROR,
      payload: error,
    }),
    'Failed to fetch archived parts',
  ),
  request: () => ({
    type: types.ARCHIVED_PARTS_LIST_REQUEST,
  }),
  success: (payload) => ({
    type: types.ARCHIVED_PARTS_LIST_SUCCESS,
    payload: {
      parts: payload.results,
      count: payload.count,
    },
  }),
};

export const draftedQuotes = {
  error: notify(
    (error) => ({
      type: types.DRAFTED_QUOTES_ERROR,
      payload: error,
    }),
    'Failed to fetch drafted quotes',
  ),
  request: () => ({
    type: types.DRAFTED_QUOTES_REQUEST,
  }),
  success: ({ draftedQuotes, hasMoreQuotes }) => ({
    type: types.DRAFTED_QUOTES_SUCCESS,
    payload: {
      draftedQuotes: draftedQuotes,
      hasMoreQuotes: hasMoreQuotes,
    },
  }),
};

export const getAdditionalQuotes = {
  error: notify(
    (error) => ({
      type: types.GET_ADDITIONAL_QUOTES_ERROR,
      payload: error,
    }),
    'Error getting quotes',
  ),
  request: () => ({
    type: types.GET_ADDITIONAL_QUOTES_REQUEST,
  }),
  success: ({ quotes, page, hasMoreQuotes }) => ({
    type: types.GET_ADDITIONAL_QUOTES_SUCCESS,
    payload: { quotes, page, hasMoreQuotes },
  }),
};

export const uploadSupportingFilesError = notify(
  () => ({
    type: types.UPLOAD_SUPPORTING_FILES_ERROR,
  }),
  'Unable to attach one or more supporting files',
);

export const mergeParts = {
  error: notify(
    (error) => ({
      type: types.MERGE_PARTS_ERROR,
      payload: error,
    }),
    'Failed to merge parts',
  ),
  request: ({ parentUuid }) => ({
    type: types.MERGE_PARTS_REQUEST,
    payload: { parentUuid },
  }),
  success: notify(
    ({ numParts }) => ({
      type: types.MERGE_PARTS_SUCCESS,
      payload: { numParts },
    }),
    (action) => `Successfully merged ${action.payload.numParts} parts`,
  ),
};
